import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/create-listing/")({
  head: () => routeHead("/uk/create-listing/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/create-listing-v2", statusCode: 301, replace: true });
  },
});
